module.exports = __webpack_public_path__ + "img/zubut-line.817ac866.png";